import React from 'react';
import styles from './loading-silent-push.module.sass';
import spLoadingMedium from '../../assets/silent-push-spinner-medium.gif';
import spLoadingDark from '../../assets/silent-push-spinner-dark.gif';
import cx from 'classnames';

const LoadingSilentPush = (props) => {
  const { size, positionCenter, background, rounded } = props;
  let imageBackground = spLoadingMedium;

  switch (background) {
    case 'dark':
      imageBackground = spLoadingDark;
      break;
    default:
      imageBackground = spLoadingMedium;
  }

  return (
    <div
      className={cx(styles.loadingSilentPush, {
        [styles.alignCenter]: positionCenter,
      })}
      style={{ width: size }}
    >
      <div
        className={cx({ [styles.rounded]: rounded })}
        style={{ width: size, height: size }}
      >
        <img
          src={imageBackground}
          alt="loading spinner"
          title="Silent Push Loading Spinner"
        />
      </div>
    </div>
  );
};

export default LoadingSilentPush;
